import { Button } from '@thanx/uikit/button'
import { Switch } from '@thanx/uikit/switch'
import { useStyletron } from '@thanx/uikit/theme'

import { buildTranslate } from 'locales'

type ModifierToggleProps = {
  children: React.ReactNode
  isVisible: boolean
  setIsVisible: (visible: boolean) => void
  isButtonDisabled?: boolean
  buttonLabel?: string
  // id of the expanded content, referenced by the button's aria-controls;
  // must be unique on the page (one card can hold two toggles)
  contentId: string
}

const t = buildTranslate('redeem_manager.modifier_select.wrapper')

const ModifierToggle = ({
  isVisible,
  setIsVisible,
  children,
  isButtonDisabled = false,
  buttonLabel,
  contentId,
}: ModifierToggleProps) => {
  const [css] = useStyletron()

  const toggleVisibility = () => setIsVisible(!isVisible)

  return (
    <>
      <Switch condition={!isVisible}>
        <Button
          kind="secondary"
          onClick={toggleVisibility}
          disabled={isButtonDisabled}
          aria-expanded={isVisible}
          aria-controls={contentId}
          className={`${css({
            width: 'fit-content',
          })} mr-s mt-m mb-s mb-sm-0`}
        >
          {buttonLabel ?? t('display')}
        </Button>
      </Switch>
      <Switch condition={isVisible}>
        <div id={contentId}>{children}</div>
      </Switch>
    </>
  )
}

export default ModifierToggle
